import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import styles from './GridPreviewModal.module.css';

/**
 * Lightweight full-screen image overlay.
 * Props: isOpen (bool), onClose (fn), previewUrl (string)
 */
const GridPreviewModal = ({ isOpen, onClose, previewUrl }) => {
  useEffect(() => {
    if (!isOpen) return;
    const handler = (e) => {
      if (e.key === 'Escape') onClose();
    };

    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    document.addEventListener('keydown', handler);
    return () => {
      document.removeEventListener('keydown', handler);
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, [isOpen, onClose]);

  if (!isOpen || !previewUrl) return null;

  return ReactDOM.createPortal(
    <div
      className={styles.backdrop}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label="Grid preview"
    >
      <button
        className={styles.closeBtn}
        onClick={onClose}
        aria-label="Close preview"
        type="button"
      >
        ×
      </button>
      <img
        src={previewUrl}
        alt="Distortion grid preview"
        className={styles.image}
        onClick={(e) => e.stopPropagation()}
        onError={onClose}
      />
    </div>
  , document.body);
};

export default GridPreviewModal;
